import {AssetType} from "../Utils";

/**
 * Stores data used to load and unload assets.
 */
export class AssetMapData {
    /**
     * The name of the asset file.
     */
    public assetName: string;
    /**
     * The type of the asset file.
     */
    public assetType: AssetType;
    /**
     * Path to the asset
     */
    public assetPath: string = "";
    /**
     * If resolution suffix is set the asset is loaded only on devices with the matched asset resolution
     */
    public resolutionSuffix: string = "";

    /**
     * @deprecated use asset classes from Load/Assets package
     * @param pAssetName
     * @param pAssetType
     */
    constructor(pAssetName: string, pAssetType: AssetType) {
        this.assetName = pAssetName;
        this.assetType = pAssetType;
    }

    public getResource(): PIXI.loaders.Resource {
        const resource = PIXI.loader.resources[this.assetName];
        if (!resource) {
            throw new Error(`Asset ${this.assetName} is not loaded.`);
        }
        return resource;
    }

    public getLoaderOptions(): PIXI.loaders.LoaderOptions | undefined {
        return undefined;
    }

    public isLoaded(): boolean {
        return !!PIXI.loader.resources[this.assetName];
    }

    public destroy(): void {
        // Additional actions required to destroy the asset
    }
}
